var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMydrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758087439054,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 53246,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1009.140569 481.100584l-157.049056-126.283955c-25.901501-20.86824-64.470985-2.375247-64.470985 30.878209v95.518853H554.676681v-244.876634h83.529513c33.253455 0 51.746448-38.51293 30.878208-64.470985L542.857001 14.817016c-15.834979-19.73717-45.921438-19.73717-61.756417 0L354.816629 171.866072c-20.86824 25.901501-2.375247 64.470985 30.878209 64.470985h95.518853v244.876634h-244.876634V385.694838c0-33.253455-38.51293-51.746448-64.470985-30.878209L14.817016 481.100584c-19.73717 15.834979-19.73717 45.921438 0 61.756417l157.049056 126.283955c25.901501 20.86824 64.470985 2.375247 64.470985-30.878209V554.733235h244.876634v232.943847H385.694838c-33.253455 0-51.746448 38.51293-30.878209 64.470984l126.283955 157.049057c15.834979 19.73717 45.921438 19.73717 61.756417 0l126.283955-157.049057c20.86824-25.901501 2.375247-64.470985-30.878209-64.470984H554.733235V554.733235h232.943847v83.529512c0 33.253455 38.51293 51.746448 64.470984 30.878209l157.049057-126.283955c19.73717-15.834979 19.73717-45.921438 0-61.756417z",
    "p-id": 53247
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydrag);
export default __webpack_public_path__ + "static/media/mydrag.bf45dd66.svg";
export { ForwardRef as ReactComponent };